import { alpha } from "@mui/material";
import useSidebar from "components/Sidebar/SidebarProvider/useSidebar";
import Span from "components/primitives/Span";
import Typography from "components/Typography";
import { memo } from "react";

interface ListItemCategoryProps {
  children: React.ReactNode;
}

function ListItemCategory(props: ListItemCategoryProps) {
  const { children } = props;
  const { open } = useSidebar();

  return (
    <>
      {open ? (
        <Typography variant="TextS" sx={{ padding: "4px 8px 0 8px", color: "grey.100" }}>
          {children}
        </Typography>
      ) : (
        <Span
          role="separator"
          aria-hidden="true"
          sx={(theme) => ({
            width: "100%",
            height: "1px",
            borderBottom: `1px solid ${alpha(theme.palette.grey[60], 0.3)}`,
          })}
        />
      )}
    </>
  );
}
export default memo(ListItemCategory);
